import * as React from "react";
import { useTranslation } from "react-i18next";
import { format } from "util";
import { Formaters } from "lib/Formarters";

////////////////////////////////////////////////////////////////////////////////////////////////

export type PreDefinedResourceFormat = "lowercase" | "uppercase" | "capitalize" | "capitalizeAll" | "capitalizedTitle";

////////////////////////////////////////////////////////////////////////////////////////////////

export function formatResource(value: any, parameters: Array<any> | PreDefinedResourceFormat) {
    if (parameters === 'uppercase') return value.toUpperCase();
    else if (parameters === 'lowercase') return value.toLowerCase();
    else if (parameters === 'capitalize') return Formaters.capitalize(value);
    else if (parameters === 'capitalizeAll') return Formaters.capitalizeAll(value);
    else if (parameters === 'capitalizedTitle') return Formaters.capitalizedTitle(value);
    return format(value, parameters);
}

////////////////////////////////////////////////////////////////////////////////////////////////

interface IAppResProps { resource: string; parameters?: Array<any> | PreDefinedResourceFormat; }

const AppResource: React.FC<IAppResProps> = (props) => {
    const { t } = useTranslation();
    var res = t(props.resource);
    if (res && props.parameters) res = formatResource(res, props.parameters);
    return (<span>{res || "?"}</span>);
};

export default AppResource;